export default __webpack_public_path__ + "media/Objective/Objective-Super-Italic-722a979daec6424bb153d389389d0cd9.woff2";